export default __webpack_public_path__ + "assets/wizard-webhook-bc4ff750323676c9083eea939e2f0775.svg";